/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// --------------------------------------------------------------------------------------
// Minimum Order Quantity
// --------------------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
  // General MOQ handler for any cart root
  function enforceMOQForCart({rootSelector, itemSelector, titleSelector, inlineErrorClass, globalErrorClass, checkoutBtnSelector, errorMsgBuilder, inlineMsgBuilder}) {
    const rootEl = document.querySelector(rootSelector);
    if (!rootEl) return;

    function collectGroups() {
      const groupData = {};
      rootEl.querySelectorAll(itemSelector).forEach(item => {
        let group = item.dataset.productGroup?.trim();
        if (!group) {
          const titleEl = item.querySelector(titleSelector);
          group = titleEl?.textContent?.trim();
        }
        const minQty = parseInt(item.dataset.minimumQty, 10) || 0;
        const qtyInput = item.querySelector('input.quantity-selector__value');
        const qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
        if (!group) return;
        if (!groupData[group]) groupData[group] = { totalQty: 0, minQty: 0 };
        groupData[group].totalQty += qty;
        groupData[group].minQty = Math.max(groupData[group].minQty, minQty);
      });
      return groupData;
    }

    function validateMinimums(groupData) {
      const errors = [];
      const failingGroups = [];
      const messageMap = {};
      for (const group in groupData) {
        const { totalQty, minQty } = groupData[group];
        if (minQty && totalQty < minQty) {
          const missing = minQty - totalQty;
          const msg = inlineMsgBuilder(group, minQty, missing);
          errors.push(msg);
          failingGroups.push(group);
          messageMap[group] = msg;
        }
      }
      renderInlineMOQErrors(failingGroups, messageMap);
      return errors;
    }

    function renderInlineMOQErrors(failingGroups, messageMap) {
      rootEl.querySelectorAll(itemSelector).forEach(item => {
        let group = item.dataset.productGroup?.trim();
        if (!group) {
          const titleEl = item.querySelector(titleSelector);
          group = titleEl?.textContent?.trim();
        }
        const existing = item.querySelector('.' + inlineErrorClass);
        if (existing) existing.remove();
        if (failingGroups.includes(group)) {
          const titleEl = item.querySelector(titleSelector);
          if (titleEl) {
            const msgEl = document.createElement('div');
            msgEl.className = inlineErrorClass;
            msgEl.textContent = messageMap[group];
            titleEl.insertAdjacentElement('afterend', msgEl);
          }
        }
      });
    }

    function showGlobalError(errors) {
      const existingBanner = rootEl.querySelector('.' + globalErrorClass);
      if (existingBanner) existingBanner.remove();
      if (errors.length === 0) return;
      const banner = document.createElement('div');
      banner.className = globalErrorClass;
      banner.setAttribute('role', 'alert');
      banner.textContent = errorMsgBuilder(errors);
      // Insert before checkout or at top
      const checkoutBtn = rootEl.querySelector(checkoutBtnSelector);
      if (checkoutBtn && checkoutBtn.parentNode) {
        checkoutBtn.parentNode.insertBefore(banner, checkoutBtn);
      } else {
        rootEl.prepend(banner);
      }
    }

    function enforceMOQ() {
      const groupData = collectGroups();
      const errors = validateMinimums(groupData);
      showGlobalError(errors);
      const checkoutBtn = rootEl.querySelector(checkoutBtnSelector);
      if (checkoutBtn) checkoutBtn.disabled = errors.length > 0;
    }

    // For live enforcement (with or without AJAX)
    ['cart:refresh', 'product:added', 'change'].forEach(ev => {
      document.addEventListener(ev, enforceMOQ);
    });
    setInterval(enforceMOQ, 1000); // fallback for unexpected updates
    enforceMOQ();

    // Prevent checkout if not valid
    rootEl.addEventListener('click', function(e) {
      const target = e.target.closest(checkoutBtnSelector);
      if (!target) return;
      const groupData = collectGroups();
      const errors = validateMinimums(groupData);
      if (errors.length > 0) {
        e.preventDefault();
        showGlobalError(errors);
      }
    });
  }

  // Main cart
  enforceMOQForCart({
    rootSelector: 'body.template-cart',
    itemSelector: '[data-product-group]',
    titleSelector: '.line-item__title',
    inlineErrorClass: 'moq-inline-error',
    globalErrorClass: 'custom-minimum-error',
    checkoutBtnSelector: 'button[name="checkout"]',
    errorMsgBuilder: errors => 'Please adjust your cart to meet the minimum order requirements.',
    inlineMsgBuilder: (group, minQty, missing) => `Need ${missing} more of “${group}” to reach minimum ${minQty}.`
  });

  // Mini cart
  enforceMOQForCart({
    rootSelector: '#mini-cart',
    itemSelector: '.mini-cart__line-item[data-product-group]',
    titleSelector: '.mini-cart__product-title',
    inlineErrorClass: 'mini-moq-inline-error',
    globalErrorClass: 'mini-custom-minimum-error',
    checkoutBtnSelector: 'button[name="checkout"]',
    inlineMsgBuilder: (group, minQty, missing) => `Minimum order is ${minQty} units. You need ${missing} more to proceed.`
  });
});
